/*
 * @Description: 
 * @Date: 2026-05-27 18:06:16
 * @LastEditTime: 2026-11-02 15:23:48
 * @FilePath: \hui_ai_ui\src\api\ai\login.js
 */
import axios from 'axios';
import { Message } from 'element-ui';
import md5 from 'js-md5';
import CryptoJS from 'crypto-js';
import { isTauri } from '@/config';
import { tauriHttp } from '@/utils/tauri-http';

const handleResponse = (response) => {
  return response.data;
};

const handleError = (error) => {
  console.error('Login API请求出错:', error);
  let errorMessage = error.message;
  if (error.response && error.response.data && error.response.data.message) {
    errorMessage = error.response.data.message;
  }
  Message({
    message: errorMessage,
    type: 'error',
    duration: 5 * 1000,
    showClose: true
  });
  return Promise.reject(error);
};

const loginService = axios.create({
  timeout: 60000
});

loginService.interceptors.request.use(
  config => {
    return config;
  },
  handleError
);

loginService.interceptors.response.use(handleResponse, handleError);

const isLocalDev = typeof window !== 'undefined' && window.location.hostname === 'localhost';

// Tauri 环境下必须使用绝对路径，因为 Tauri HTTP 插件不支持相对路径解析
const _useAbsoluteUrl = isTauri || !isLocalDev;
/**
 * 传输层适配（登录 / 重置密码等公共接口）
 */
function nativeRequest({ service = 'login', url, method = 'POST', data = null, params = {}, headers = {} }) {
  return tauriHttp({ service, url, method, data, params, headers }).then(res => {
    if (!res || res.success === false) {
      const message = (res && (res.error || (res.data && (res.data.message || res.data.msg)))) || '请求失败，请稍后重试';
      Message({
        message,
        type: 'error',
        duration: 5 * 1000,
        showClose: true
      });
      const err = new Error(message);
      err.response = { data: res && res.data };
      return Promise.reject(err);
    }
    return res.data;
  });
}

function loginRequest(service, method, path, { data = null, params = {}, headers = {} } = {}) {
  if (isTauri) {
    return nativeRequest({ service, url: path, method, data, params, headers });
  }
  const url = `${API_CONFIG[service].baseURL}${path}`;
  if (String(method).toUpperCase() === 'GET') {
    return loginService.get(url, { params, headers });
  }
  return loginService.post(url, data, { headers });
}

const API_CONFIG = {
  login: {
    baseURL: _useAbsoluteUrl ? 'https://loginf.lawxp.com/' : '/loginapi/',
    endpoints: {
      getCodeImg: 'Auth/GetCodeImg',
      getSecretKey: 'Auth/GetSecretKey',
      sendVerificationCode: 'Auth/APPSendCode',
      verificationLogin: 'Auth/GetTokenByPhone',
      accountLogin: 'Auth/GteTokenByAccountPwd',
      getUserInfo: 'F_UserInfo/GetUserInfoByToken',
      setPassword: 'Auth/SetPwd',
      showUserInfo: 'F_UserInfo/Show'
    }
  },
  tuansudi: {
    baseURL: 'https://api.tuansudi.com/',
    endpoints: {
      getIP: 'api/Synthetical/GetIP'
    }
  },
  xinfushenghuo: {
    baseURL: _useAbsoluteUrl ? 'https://api1.xinfushenghuo.cn/' : '/xinfushenghuo/',
    endpoints: {
      getAgreement: 'apishop/article/info'
    }
  },
  im: {
    baseURL: _useAbsoluteUrl ? 'https://im.xinfushenghuo.cn/' : '/imapi/',
    endpoints: {
      userRegister: 'j_user/userRegister'
    }
  }
};

export function getIP() {
  return loginRequest('tuansudi', 'GET', API_CONFIG.tuansudi.endpoints.getIP);
}

export function getAgreement(code) {
  return loginRequest('xinfushenghuo', 'GET', API_CONFIG.xinfushenghuo.endpoints.getAgreement, {
    params: { code, id: 0 }
  });
}

export function getCodeImg(imgKey) {
  return loginRequest('login', 'GET', API_CONFIG.login.endpoints.getCodeImg, {
    params: { ImgKey: imgKey }
  });
}

export function getSecretKey(params) {
  return loginRequest('login', 'POST', API_CONFIG.login.endpoints.getSecretKey, { data: params });
}

export function sendVerificationCode(data) {
  return loginRequest('login', 'POST', API_CONFIG.login.endpoints.sendVerificationCode, { data });
}

export function verificationLogin(params) {
  return loginRequest('login', 'POST', API_CONFIG.login.endpoints.verificationLogin, { data: params });
}

export function accountLogin(params) {
  return loginRequest('login', 'POST', API_CONFIG.login.endpoints.accountLogin, { data: params });
}

export function getUserInfo(params, headers = {}) {
  return loginRequest('login', 'POST', API_CONFIG.login.endpoints.getUserInfo, { data: params, headers });
}

// 重置密码（与登录同域：https://loginf.lawxp.com/Auth/SetPwd）
export function setPassword(data) {
  return loginRequest('login', 'POST', API_CONFIG.login.endpoints.setPassword, { data });
}

export function showUserInfo(params) {
  const pctoken = sessionStorage.getItem('pctoken');
  const headers = {};
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
  }
  return loginRequest('login', 'POST', API_CONFIG.login.endpoints.showUserInfo, { data: params, headers });
}

export function userRegister(data, headers = {}) {
  return loginRequest('im', 'POST', API_CONFIG.im.endpoints.userRegister, { data, headers });
}

export function getUserId(id) {
  return loginService.get(`/api/v1/common/get_user_id/${id}`);
}

export function saveToken(data) {
  return loginService.post('/api/v1/common/save_token', data);
}

const SIGN_SECRET = 'JSU$E&H@F';
const SIGN_KEYS = ['Code','DeviceType','IP','Phone','Time'];
export function generateSign(params) {
  let encryString = '';
  for (const key of SIGN_KEYS) {
    encryString += (params[key] || '') + ',';
  }
  encryString += SIGN_SECRET;
  // console.log("encryString",encryString);
  return md5(encryString);
}

export function desEncrypt(plaintext, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.DES.encrypt(CryptoJS.enc.Utf8.parse(plaintext), keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
